import { useTheme } from '@/contexts/ThemeContext';
import type { ReactNode } from 'react';

export interface ContentContainerProps {
  children: ReactNode;
}

/**
 * Conteneur principal du contenu de l'application.
 * Zone de rendu des pages (Outlet).
 */
export function ContentContainer({ children }: ContentContainerProps) {
  const { resolvedTheme } = useTheme();

  const getMainBgClass = () => {
    if (resolvedTheme === 'light') return 'bg-gray-50';
    if (resolvedTheme === 'dark') return 'bg-slate-900';
    return 'bg-gray-50';
  };

  return (
    <div className="flex-1 flex flex-col min-h-0 overflow-hidden">
      <main className={`flex-1 min-h-0 relative overflow-hidden ${getMainBgClass()}`}>
        {children}
      </main>
    </div>
  );
}
